<h1>Angular UI Scroll Experimental Demos</h1>
<p>
  There are some undocumented settings and Adapter methods that provide
  additional flexibility. We can consider them as experimental features. Most of
  these features are not tested well and may have some side effects or behave
  imperfectly.
</p>
<ul>
  <li>
    <a routerLink="{{ base }}" fragment="{{ scope.viewportElementSetting.id }}">
      {{ scope.viewportElementSetting.name }}
    </a>
  </li>
  <li>
    <a routerLink="{{ base }}" fragment="{{ scope.inverseSetting.id }}">
      {{ scope.inverseSetting.name }}
    </a>
  </li>
  <li>
    fix adapter method:
    <a routerLink="{{ base }}" fragment="{{ scope.adapterFixPosition.id }}"
      >position</a
    >,
    <a routerLink="{{ base }}" fragment="{{ scope.adapterFixUpdater.id }}"
      >updater</a
    >,
    <a routerLink="{{ base }}" fragment="{{ scope.adapterFixScrollToItem.id }}"
      >scroll to item</a
    >
  </li>
  <li>
    <a routerLink="{{ base }}" fragment="{{ scope.onBeforeClipSetting.id }}">
      {{ scope.onBeforeClipSetting.name }}
    </a>
  </li>
  <li>
    <a routerLink="{{ base }}" fragment="{{ scope.routines.id }}">
      {{ scope.routines.name }}
    </a>
  </li>
</ul>
<p>
  For example, <em>Adapter.fix</em> method. It has different options for
  different cases which are discussed below. These options are passed as an
  object of the following type:
</p>
<pre>{{ adapterFixArgumentDescription }}</pre>
<app-viewport-element-setting></app-viewport-element-setting>
<app-inverse-setting></app-inverse-setting>
<app-adapter-fix-position></app-adapter-fix-position>
<app-adapter-fix-updater></app-adapter-fix-updater>
<app-adapter-fix-scroll-to-item></app-adapter-fix-scroll-to-item>
<app-on-before-clip-setting></app-on-before-clip-setting>
<app-routines></app-routines>
